import getApiUrl from "../utils/apiUrl";
import fetch from "../utils/mgFetch";

const deleteCustomerObject = (
    backend: string,
    token: string,
    id: number
) => {
    return fetch(
        `${getApiUrl(backend)}customerobjects/${id}`,
        {
            method: 'DELETE',
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json"
            },
        }
    );
};

export default deleteCustomerObject;
